import { takeEvery } from "redux-saga/effects";
import trackRequests from "rdx/utils/trackRequests";

import types from "rdx/modules/emailVerification/types";
import verifyEmail from "./verifyEmail";
import resendVerificationEmail from "./resendVerificationEmail";
// IMPORT_PT (for script, do not remove)

function* watchEmailVerificationSagas() {
  yield trackRequests(takeEvery, types.VERIFY_EMAIL_REQUEST, verifyEmail);
  yield trackRequests(takeEvery, types.RESEND_VERIFICATION_EMAIL_REQUEST, resendVerificationEmail);
  // INSERTION_PT (for script, do not remove)
}

export default watchEmailVerificationSagas;
